<template>
  <div
    class="offcanvas offcanvas-fullscreen-sm-down offcanvas-end"
    tabindex="-1"
    id="offcanvaInfo"
    ref="offcanvaInfo"
    data-bs-backdrop="static"
  >
    <!-- data-bs-backdrop="static" -->
    <div class="bg-top-nav border offcanvas-header py-2">
      {{ $t('Shift Detail')  }}
      <button
        type="button"
        style="font-size: small;"
        class="btn-close shadow-none text-reset"
        data-bs-dismiss="offcanvas"
        aria-label="Close"
      />
    </div>

    <div
      class="offcanvas-body"
      v-if="loading"
    >
      <placeholder-content :is-load="true" />
    </div>
    <div
      class="offcanvas-body"
      v-else-if="!hasPermission"
    >
      <access-denied/>
    </div>
    <div
      class="offcanvas-body p-0"
      v-else
    >
      <div class="border-bottom py-2 px-3">
        <div class="d-flex">
          <div class="row g-3 py-2">
            <b style="font-size: 18px;" class="mt-2">
              {{ data.branch }}
              <span
                style="text-transform: capitalize"
                :class="['badge', data.status == 'Open'? 'bg-success': 'bg-danger']"
              >
                <i
                  class="fas me-1"
                  :class="[data.status == 'Open'? 'fa-check-circle': 'fa-times-circle']"
                />
                {{ $t(data.status) }}
              </span>
            </b>
            <div
              class="d-flex mt-0 "
              style="font-size: 13px;"
            >
              <label
                class="pe-2"
              >
                {{ $t('Last Update') + ': ' + formatDateTime(data.updated_at) }}
              </label>
            </div>
          </div>
        </div>
      </div>
      <div
        class="card m-3"
      >
        <!-- <div class="card-header">
          <b>
            {{ $t('Shift Information') }}
          </b>
        </div> -->
        <div class="card-body pb-0">
          <div class="row" style="font-size: 13px;">
            <div class="col-md-3 mb-3">
              <b>
                {{ $t('Opened By') }}
              </b><br>
              {{ data.opened_by }}
            </div>
            <div class="col-md-3 mb-3">
              <b>
                {{ $t('Start Time') }}
              </b><br>
              {{ formatDateTime(data.opened_at) }}
            </div>
            <div class="col-md-3 mb-3">
              <b>
                {{ $t('Closed By') }}
              </b><br>
              {{ data.closed_by? data.closed_by: '-' }}
            </div>
            <div class="col-md-3 mb-3">
              <b>
                {{ $t('End Time') }}
              </b><br>
              {{ data.closed_at? formatDateTime(data.closed_at): '-' }}
            </div>
          </div>
        </div>
      </div>
      <div class="m-3">
        <div class="row g-3">
          <div class="col-md-4">
            <div
              class="card h-100"
            >
              <div class="bg-white card-header">
                <b>
                  {{ $t('Sales & Revenue') }}
                </b>
              </div>
              <div class="card-body">
                <div class="gx-0 row">
                  <div
                    class="border-bottom col-12 d-flex justify-content-between mt-2 pb-1"
                  >
                    <span>
                      {{ $t('Gross Sales') + ':' }}
                    </span>
                    <span>
                      {{ $storeIndex.formatThaiCurrency(data.gross_sales) }}
                    </span>
                  </div>
                  <div
                    class="border-bottom col-12 d-flex justify-content-between mt-2 pb-1"
                  >
                    <span>
                      {{ $t('Total Discounts') + ':' }}
                    </span>
                    <span>
                      {{ '-' + $storeIndex.formatThaiCurrency(data.total_discount) }}
                    </span>
                  </div>
                  <div
                    class="col-12 d-flex justify-content-between mt-2 text-danger pb-1"
                  >
                    <span>
                      <i class='fas fa-undo'/>
                      {{ $t('Total Refunds') + ':' }}
                    </span>
                    <span>
                      {{ '-' + $storeIndex.formatThaiCurrency(data.total_refund) }}
                    </span>
                  </div>
                  <div
                    class="col-md-12 mt-2"
                  >
                    <div
                      class="bg-secondary-subtle card"
                    >
                      <div class="card-body p-2 d-flex justify-content-between">
                        <h6 class="m-0">
                          {{ $t('Net Sales') }}
                        </h6>
                        <h6 class="m-0">
                          {{ $storeIndex.formatThaiCurrency(data.net_sales) }}
                        </h6>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-8">
            <div
              class="card"
            >
              <div class="bg-white card-header">
                <b>
                  {{ $t('Cash Drawer Movement') }}
                </b>
              </div>
              <div class="card-body">
                <div class="gx-0 row">
                  <div
                    class="border-bottom col-12 d-flex justify-content-between mt-2 pb-1"
                  >
                    <span>
                      {{ $t('Starting Cash') + ':' }}
                    </span>
                    <span>
                      {{ $storeIndex.formatThaiCurrency(data.starting_cash) }}
                    </span>
                  </div>
                  <div
                    class="border-bottom col-12 d-flex justify-content-between mt-2 pb-1"
                  >
                    <span>
                      {{ $t('Cash Sales') + ':' }}
                    </span>
                    <span>
                      {{ $storeIndex.formatThaiCurrency(data.cash_sales) }}
                    </span>
                  </div>
                  <div
                    class="border-bottom col-12 d-flex justify-content-between mt-2 pb-1"
                  >
                    <span>
                      {{ $t('Pay In') + ':' }}
                    </span>
                    <span>
                      {{ $storeIndex.formatThaiCurrency(data.total_pay_in) }}
                    </span>
                  </div>
                  <div
                    class="col-12 d-flex justify-content-between mt-2 pb-1"
                  >
                    <span>
                      {{ $t('Pay Out') + ':' }}
                    </span>
                    <span
                      class="text-danger"
                    >
                      {{ '-' + $storeIndex.formatThaiCurrency(data.total_pay_out) }}
                    </span>
                  </div>
                  <div
                    class="col-md-12 mt-2"
                  >
                    <div
                      class="bg-secondary-subtle border-black card"
                    >
                      <div class="card-body p-2 d-flex justify-content-between">
                        <h6 class="m-0">
                          {{ $t('Expected Cash') }}
                        </h6>
                        <h6 class="m-0">
                          {{ $storeIndex.formatThaiCurrency(expectedCash) }}
                        </h6>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              class="card mt-3"
              v-if="data.note"
            >
              <div class="card-body">
                <i class="fas fa-comment-dots me-1"/>
                <b>
                  {{ $t('Note') + ': ' }}
                </b>
                {{ data.note }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        class="card m-3"
      >
        <div class="bg-white card-header">
          <b>
            {{ $t('Reconciliation Summary') }}
          </b>
        </div>
        <div class="card-body p-0">
          <div
            class="overflow-x-auto"
          >
            <table class="mb-1 table table-sm">
              <thead class="table-light">
                <tr>
                  <th
                    style="text-transform: uppercase; min-width: 150px;"
                    class="ps-3"
                  >
                    {{ $t('Payment Method') }}
                  </th>
                  <th
                    class="text-end"
                    :class="[data.status == 'Open'? 'pe-3': '']"
                    style="text-transform: uppercase; min-width: 150px;max-width: 150px;width: 150px;"
                  >
                    {{ $t('Expected') }}
                  </th>
                  <th
                    class="text-end"
                    style="text-transform: uppercase; min-width: 150px;max-width: 150px;width: 150px;"
                    v-if="data.status == 'Close'"
                  >
                    {{ $t('Actual') }}
                  </th>
                  <th
                    class="text-end pe-3"
                    style="text-transform: uppercase; min-width: 150px;max-width: 150px;width: 150px;"
                    v-if="data.status == 'Close'"
                  >
                    {{ $t('Difference') }}
                  </th>
                </tr>
              </thead>
              <!-- ช่องทางตามที่สาขานั้นเปิดใช้จริง (กะที่ปิดแล้ว = snapshot ตอนปิด) -->
              <tbody>
                <tr
                  v-for="(payment, index) in (data.payment_breakdown ?? [])"
                  :key="payment.branch_payment_method_id || ('method-' + payment.payment_method_id)"
                >
                  <td
                    class="ps-3"
                    :class="[isLastPayment(index)? 'border-bottom-0': '']"
                  >
                    {{ $t(payment.label) }}
                    <!-- ยอดนี้ถูกแก้หลังปิดกะ — ต้องเห็นว่าไม่ใช่ยอดที่นับไว้ตอนปิดจริง ๆ -->
                    <span
                      class="badge bg-warning-subtle text-warning-emphasis ms-1"
                      style="font-weight: 500;"
                      v-if="payment.is_adjusted"
                      :title="$t('Adjusted By') + ': ' + payment.adjusted_by + ' · ' + formatDateTime(payment.adjusted_at)"
                    >
                      <i class="fa-solid fa-clock-rotate-left me-1" />
                      {{ $t('Adjusted After Close') }}
                    </span>
                    <div
                      class="text-muted"
                      style="font-size: 12px;"
                      v-for="(item, index) in (payment.adjustments ?? [])"
                      :key="index"
                    >
                      {{ (item.old_actual === ''? $t('Not Counted'): $storeIndex.formatThaiCurrency(item.old_actual))
                        + ' → ' + $storeIndex.formatThaiCurrency(item.new_actual)
                        + ' · ' + item.adjusted_by + ' · ' + formatDateTime(item.adjusted_at) }}
                      <div class="fst-italic">{{ item.reason }}</div>
                    </div>
                  </td>
                  <td
                    class="text-end"
                    :class="[data.status == 'Open'? 'pe-3': '', isLastPayment(index)? 'border-bottom-0': '']"
                  >
                    {{ $storeIndex.formatThaiCurrency(payment.expected_amount) }}
                  </td>
                  <td
                    class="text-end"
                    :class="[isLastPayment(index)? 'border-bottom-0': '']"
                    v-if="data.status == 'Close'"
                  >
                    {{ payment.actual_amount === ''? '-': $storeIndex.formatThaiCurrency(payment.actual_amount) }}
                  </td>
                  <td
                    class="text-end pe-3"
                    :class="[isLastPayment(index)? 'border-bottom-0': '']"
                    v-if="data.status == 'Close'"
                  >
                    <!-- ช่องทางที่พนักงานไม่ได้ยืนยันยอด = ไม่มีส่วนต่างให้เทียบ -->
                    {{
                      payment.difference === ''? $t('Not Counted'):
                      $storeIndex.formatThaiCurrency(payment.difference) + ' ' +
                      (payment.difference == 0? '('+$t('Match')+')': payment.difference < 0? '('+$t('Short')+')': '('+$t('Over')+')')
                    }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    <div
      class="bg-light border-top justify-content-center modal-footer py-2"
      v-if="!loading"
    >
      <!-- แต่ละสถานะมี action เดียว จึงเป็นปุ่มตรง ๆ ไม่ต้องผ่าน dropdown
           กะเปิด = แก้ข้อมูลกะ · กะปิด = แก้ได้แค่ยอดที่นับได้ และถูกบันทึกว่าใครแก้
           คนละไอคอน/คำโดยตั้งใจ — สองปุ่มนี้ไม่เคยโผล่พร้อมกัน ไอคอนจึงเป็นสัญญาณเดียว
           ที่บอกว่าเป็นคนละน้ำหนัก -->
      <button
        type="button"
        class="btn btn-sm btn-primary"
        data-bs-dismiss="offcanvas"
        aria-label="Close"
        v-if="data.status === 'Open'"
        @click="$emit('edit-shift', id)"
      >
        <i class="fa-solid fa-square-pen me-1" />
        {{ $t('Edit') }}
      </button>
      <button
        type="button"
        class="btn btn-sm btn-primary"
        data-bs-dismiss="offcanvas"
        aria-label="Close"
        v-else-if="canAdjust"
        @click="$emit('adjust-shift', id)"
      >
        <i class="fa-solid fa-scale-balanced me-1" />
        {{ $t('Adjust Counted Amount') }}
      </button>
      <button
        type="button"
        data-bs-dismiss="offcanvas"
        class="border-dark-subtle btn-sm btn btn-light me-2 ms-2"
      >
        {{ $t('Cancel') }}
      </button>
    </div>
  </div>
</template>

<script lang="js">
import { Shifts } from '@/services/endpoint/pos.service';
import PlaceholderContent from '@/plugins/PlaceholderContent.vue';
import AccessDenied from "@/plugins/AccessDenied.vue";
import Ladda from '@/plugins/Ladda.vue';
import moment from "moment";
import numeral from 'numeral';
import { distance } from '@/store/date-fns'

export default {
  props: {
    id: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      loading: true,
      hasPermission: false,
      data: {
      },
      expectedCash: 0
    }
  },
  components: {
    PlaceholderContent,
    AccessDenied,
    Ladda
  },
  methods: {
    formatNumber(value) {
      return numeral(value).format("0,0");
    },
    formatDigit(value) {
      if ((value < 0.01) && value != 0) {
        return numeral(value).format("0,0.0000");
      }
      return numeral(value).format("0,0.00");
    },
    formatNumberDigit(value) {
      return numeral(value).format("0,0.0000");
    },
    formatNumberTwoDigit(value) {
      return numeral(value).format("0,0.00");
    },
    isLastPayment(index) {
      return index === (this.data.payment_breakdown ?? []).length - 1;
    },
    async getInfoData() {
      this.loading = true;
      await Shifts.getInfo(this.id).then(res => {
        this.data = res.data.data;
        // เงินสดคาดในลิ้นชักคำนวณจาก server (หัก total_refund ให้แล้ว)
        this.expectedCash = parseFloat(this.data.expected_cash);
        this.hasPermission = true;
        this.loading = false;
      }).catch(err => {
        this.hasPermission = false;
        this.loading = false;
			  throw err;
      });
    },
    formatDate(value) {
      return moment(value).format('DD/MM/YYYY');
    },
    formatDateTime(value) {
      return moment(value).format('YYYY-MM-DD HH:mm:ss');
    },
  },
  async mounted() {
    $(this.$refs.offcanvaInfo).offcanvas('show');

    $(this.$refs.offcanvaInfo).on('shown.bs.offcanvas',async () => {
      try {
        await this.getInfoData();
      } catch (err) {
      }
    });

    $(this.$refs.offcanvaInfo).on('hidden.bs.offcanvas', () => {
      this.$emit('close');
    });
  },
  computed: {
    // กะที่ปิดก่อนมี shift_payment_totals (ก่อน 2026-09-06) ไม่มีแถวให้อ้าง id — แก้ไม่ได้
    // ซ่อนเมนูตั้งแต่ตรงนี้ ดีกว่าปล่อยให้เปิดฟอร์มแล้ว API ปฏิเสธ
    canAdjust() {
      return this.data.status === 'Close'
        && (this.data.payment_breakdown ?? []).some(payment => payment.id);
    }
  },
  watch: {
  }
}
</script>
